import "./new-util-service.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilService from "../form-util-service/form-util-service";
import { useNewUtilService } from "./new-util-service.hook";

export function NewUtilService() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewUtilService();

  return (
    <div id="NewUtilService" className="util-service">
      <HeaderContent
        title={<h1>New Service</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormUtilService />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewUtilService;
